import {
  AvailityDiagnoses,
  AvailityProcedures,
  AvailityProvider,
} from "risa-data-model";

// TODO move this to remote config
export const ServiceTypeList = [
  { value: "84", label: "Abortion" },
  { value: "GY", label: "Allergy" },
  { value: "13", label: "Ambulatory Service Center Facility" },
  { value: "7", label: "Anesthesia" },
  { value: "BG", label: "Cardiac Rehabilitation" },
  { value: "78", label: "Chemotherapy" },
  { value: "33", label: "Chiropractic" },
  { value: "35", label: "Dental Care" },
  { value: "5", label: "Diagnostic Lab" },
  { value: "73", label: "Diagnostic Medical" },
  { value: "4", label: "Diagnostic X-Ray" },
  { value: "76", label: "Dialysis" },
  { value: "DM", label: "Durable Medical Equipment" },
  { value: "12", label: "Durable Medical Equipment Purchase" },
  { value: "18", label: "Durable Medical Equipment Rental" },
  { value: "86", label: "Emergency Services" },
  { value: "82", label: "Family Planning" },
  { value: "CO", label: "Flu Vaccination" },
  { value: "60", label: "General Benefits" },
  { value: "BT", label: "Gynecological" },
  { value: "30", label: "Health Benefit Plan Coverage" },
  { value: "42", label: "Home Health Care" },
  { value: "45", label: "Hospice" },
  { value: "47", label: "Hospital" },
  { value: "53", label: "Hospital - Ambulatory Surgical" },
  { value: "51", label: "Hospital - Emergency Accident" },
  { value: "52", label: "Hospital - Emergency Medical" },
  { value: "48", label: "Hospital - Inpatient" },
  { value: "50", label: "Hospital - Outpatient" },
  { value: "80", label: "Immunizations" },
  { value: "61", label: "In-vitro Fertilization" },
  { value: "83", label: "Infertility" },
  { value: "59", label: "Licensed Ambulance" },
  { value: "CM", label: "Mammogram, High Risk Patient" },
  { value: "CN", label: "Mammogram, Low Risk Patient" },
  { value: "BE", label: "Massage Therapy" },
  { value: "69", label: "Maternity" },
  { value: "1", label: "Medical Care" },
  { value: "MH", label: "Mental Health" },
  { value: "CG", label: "Mental Health Facility - Inpatient" },
  { value: "CH", label: "Mental Health Facility - Outpatient" },
  { value: "CE", label: "Mental Health Provider - Inpatient" },
  { value: "CF", label: "Mental Health Provider - Outpatient" },
  { value: "62", label: "MRI/CAT Scan" },
  { value: "65", label: "Newborn Care" },
  { value: "BU", label: "Obstetrical" },
  { value: "BV", label: "Obstetrical/Gynecological" },
  { value: "AD", label: "Occupational Therapy" },
  { value: "40", label: "Oral Surgery" },
  { value: "BH", label: "Pediatric" },
  { value: "88", label: "Pharmacy" },
  { value: "AE", label: "Physical Medicine" },
  { value: "PT", label: "Physical Therapy" },
  { value: "BY", label: "Physician Visit - Office: Sick" },
  { value: "BZ", label: "Physician Visit - Office: Well" },
  { value: "93", label: "Podiatry" },
  { value: "A3", label: "Professional (Physician) Visit - Home" },
  { value: "99", label: "Professional (Physician) Visit - Inpatient" },
  { value: "98", label: "Professional (Physician) Visit - Office" },
  { value: "A0", label: "Professional (Physician) Visit - Outpatient" },
  { value: "A7", label: "Psychiatric - Inpatient" },
  { value: "A8", label: "Psychiatric - Outpatient" },
  { value: "A6", label: "Psychotherapy" },
  { value: "6", label: "Radiation Therapy" },
  { value: "A9", label: "Rehabilitation" },
  { value: "81", label: "Routine Physical" },
  { value: "CL", label: "Screening Laboratory" },
  { value: "CK", label: "Screening X-ray" },
  { value: "20", label: "Second Surgical Opinion" },
  { value: "AG", label: "Skilled Nursing Care" },
  { value: "AF", label: "Speech Therapy" },
  { value: "AI", label: "Substance Abuse" },
  { value: "CI", label: "Substance Abuse Facility - Inpatient" },
  { value: "CJ", label: "Substance Abuse Facility - Outpatient" },
  { value: "2", label: "Surgical" },
  { value: "8", label: "Surgical Assistance" },
  { value: "CD", label: "Surgical Benefits - Facility" },
  { value: "CC", label: "Surgical Benefits - Professional (Physician)" },
  { value: "70", label: "Transplants" },
  { value: "UC", label: "Urgent Care" },
  { value: "AL", label: "Vision (Optometry)" },
  { value: "68", label: "Well Baby Care" },
];

export const PlaceOfServiceList = [
  { value: "1", label: "Ambulatory Surgical Center" },
  { value: "2", label: "Doctor's Office" },
  { value: "3", label: "Emergency Room – Hospital" },
  { value: "4", label: "Home" },
  { value: "5", label: "Hospice" },
  { value: "6", label: "Hospital – Inpatient" },
  { value: "7", label: "Hospital – Outpatient" },
  { value: "8", label: "Independent Clinic" },
  { value: "9", label: "Laboratory" },
  { value: "10", label: "Nursing Facility" },
  { value: "11", label: "Other Locations" },
  { value: "12", label: "Pharmacy" },
  { value: "13", label: "Rehabilitation Facility" },
  { value: "14", label: "Skilled Nursing Facility" },
  { value: "15", label: "Urgent Care Facility" },
];

export const SubtypeList = [
  { value: "1", label: "Initial Request" },
  { value: "2", label: "Concurrent Review" },
  { value: "3", label: "Retrospective Review" },
  { value: "4", label: "Appeal" },
  { value: "5", label: "Pharmacy" },
  { value: "6", label: "Specialty" },
  { value: "7", label: "Durable Medical Equipment (DME)" },
];

export const UrgencyTypeList = [
  { value: "1", label: "Routine" },
  { value: "2", label: "Urgent" },
  { value: "3", label: "Immediate" },
];

export const initializeAvailityProvider = (): AvailityProvider => ({
  lastName: undefined,
  firstName: undefined,
  middleName: undefined,
  suffix: undefined,
  npi: undefined,
  taxId: undefined,
  payerAssignedProviderId: undefined,
  submitterId: undefined,
  specialty: undefined,
  specialtyCode: undefined,
  addressLine1: undefined,
  addressLine2: undefined,
  city: undefined,
  state: undefined,
  stateCode: undefined,
  zipCode: undefined,
  contactName: undefined,
  phone: undefined,
  extension: undefined,
  fax: undefined,
  emailAddress: undefined,
  url: undefined,
  role: undefined,
  roleCode: undefined,
});

export const initializeAvailityDiagnosis = (): AvailityDiagnoses => ({
  qualifier: undefined,
  qualifierCode: undefined,
  value: undefined,
  date: undefined,
});

export const initializeAvailityProcedure = (): AvailityProcedures => ({
  status: undefined,
  statusCode: undefined,
  certificationIssueDate: undefined,
  certificationEffectiveDate: undefined,
  certificationExpirationDate: undefined,
  certificationNumber: undefined,
  qualifier: undefined,
  qualifierCode: undefined,
  value: undefined,
  code: undefined,
  modifier1: undefined,
  modifier1Code: undefined,
  modifier2: undefined,
  modifier2Code: undefined,
  modifier3: undefined,
  modifier3Code: undefined,
  modifier4: undefined,
  modifier4Code: undefined,
  description: undefined,
  quantity: undefined,
  quantityType: undefined,
  quantityTypeCode: undefined,
  fromDate: undefined,
  toDate: undefined,
  traceNumbers: undefined,
});

export interface KeyLabelElementObject {
  key: string;
  label: string;
  element?: any;
  filledValue?: any;
}

export const AddAnotherProviderAddButton = "AddAnotherProviderAddButton";

export const AddAnotherDiagnosisAddButton = "AddAnotherDiagnosesAddButton";

export const AddAnotherProcedureAddButton = "AddAnotherProceduresAddButton";

export const AvailityProcedureElements = (
  index: number,
  headingIndex: Number,
) => [
  {
    key: `proceduresHeading_${index}`,
    label: `Procedures ${headingIndex}`,
    element: {
      label: `Procedures ${headingIndex}`,
      type: "Heading",
      key: `proceduresHeading_${index}`,
    },
  },
  {
    key: `procedures.code_${index}`,
    label: "Procedure Code",
  },
  {
    key: `procedures.qualifierCode_${index}`,
    label: "Procedure Qualifier",
  },
  {
    key: `procedures.modifierCode1_${index}`,
    label: "Modifier 1",
  },
  {
    key: `procedures.modifierCode2_${index}`,
    label: "Modifier 2",
  },
  {
    key: `procedures.modifierCode3_${index}`,
    label: "Modifier 3",
  },
  {
    key: `procedures.modifierCode4_${index}`,
    label: "Modifier 4",
  },
  {
    key: `procedures.fromDate_${index}`,
    label: "Procedure From Date",
  },
  {
    key: `procedures.toDate_${index}`,
    label: "Procedure To Date",
  },
  {
    key: `procedures.serviceQuantityTypeCode_${index}`,
    label: "Procedure Service Quantity Type",
  },
  {
    key: `procedures.serviceQuantity_${index}`,
    label: "Procedure Service Quantity",
  },
  {
    key: `procedures.timePeriodQuantityQualifier_${index}`,
    label: "Time Period Quantity Qualifier",
  },
  {
    key: `procedures.timePeriodQuantity_${index}`,
    label: "Time Period Quantity",
  },
  {
    key: `procedures.timeframeFrequencyQualifier_${index}`,
    label: "Timeframe Frequency Qualifier",
  },
  {
    key: `procedures.timeframeFrequency_${index}`,
    label: "Timeframe Frequency",
  },
];

export const DiagnosisElements = (index: number, headingIndex: Number) => [
  {
    key: `diagnosesHeading_${index}`,
    label: `Diagnoses ${headingIndex}`,
    element: {
      label: `Diagnoses ${headingIndex}`,
      type: "Heading",
      key: `diagnosesHeading_${index}`,
    },
  },
  {
    key: `diagnoses.qualifierCode_${index}`,
    label: "Diagnosis Qualifier",
  },
  {
    key: `diagnoses.code_${index}`,
    label: "Diagnosis Code",
  },
  {
    key: `diagnoses.date_${index}`,
    label: "Diagnosis Date",
  },
];

export const RenderingProviderElements = (
  index: number,
  headingIndex: Number,
) => [
  {
    key: `renderingProvidersHeading_${index}`,
    label: `Rendering Provider ${headingIndex}`,
    element: {
      label: `Rendering Provider ${headingIndex}`,
      type: "Heading",
      key: `renderingProvidersHeading_${index}`,
    },
  },
  {
    key: `renderingProviders.firstName_${index}`,
    label: "Rendering Provider First Name",
  },
  {
    key: `renderingProviders.lastName_${index}`,
    label: "Rendering Provider Last Name",
  },
  {
    key: `renderingProviders.npi_${index}`,
    label: "Rendering Provider NPI",
  },
  {
    key: `renderingProviders.taxId_${index}`,
    label: "Rendering Provider Tax ID",
  },
  {
    key: `renderingProviders.payerAssignedProviderId_${index}`,
    label: "Rendering Provider Payer Assigned Provider ID",
  },
  {
    key: `renderingProviders.specialtyCode_${index}`,
    label: "Rendering Provider Specialty",
  },
  {
    key: `renderingProviders.roleCode_${index}`,
    label: "Rendering Provider Role",
  },
  {
    key: `renderingProviders.addressLine1_${index}`,
    label: "Rendering Provider Address Line 1",
  },
  {
    key: `renderingProviders.addressLine2_${index}`,
    label: "Rendering Provider Address Line 2",
  },
  {
    key: `renderingProviders.city_${index}`,
    label: "Rendering Provider City",
  },
  {
    key: `renderingProviders.stateCode_${index}`,
    label: "Rendering Provider State",
  },
  {
    key: `renderingProviders.zipCode_${index}`,
    label: "Rendering Provider ZIP Code",
  },
];

export const keyLabelElementObjects: KeyLabelElementObject[] = [
  { key: "serviceDetailsHeading", label: "Service Details" },
  { key: "requestTypeCode", label: "Request Type" },
  { key: "serviceTypeCode", label: "Service Type" },
  { key: "quantityTypeCode", label: "Quantity Type" },
  { key: "quantity", label: "Quantity" },
  { key: "fromDate", label: "From Date" },
  { key: "toDate", label: "To Date" },
  { key: "serviceLevelCode", label: "Level Of Service" },
  { key: "placeOfServiceCode", label: "Place of Service" },
  {
    key: "requestingProviderHeading",
    label: "Requesting Provider",
  },
  {
    key: "requestingProvider.firstName",
    label: "Requesting Provider First Name",
  },
  {
    key: "requestingProvider.lastName",
    label: "Requesting Provider Last Name",
  },
  {
    key: "requestingProvider.npi",
    label: "Requesting Provider NPI",
  },
  {
    key: "requestingProvider.taxId",
    label: "Requesting Provider Tax ID",
  },
  {
    key: "requestingProvider.payerAssignedProviderId",
    label: "Requesting Provider Payer Assigned Provider ID",
  },
  {
    key: "requestingProvider.specialtyCode",
    label: "Requesting Provider Specialty",
  },
  {
    key: "requestingProvider.roleCode",
    label: "Provider Type",
  },
  {
    key: "requestingProvider.addressLine1",
    label: "Requesting Provider Address Line 1",
  },
  {
    key: "requestingProvider.addressLine2",
    label: "Requesting Provider Address Line 2",
  },
  {
    key: "requestingProvider.city",
    label: "Requesting Provider City",
  },
  {
    key: "requestingProvider.stateCode",
    label: "Requesting Provider State",
  },
  {
    key: "requestingProvider.zipCode",
    label: "Requesting Provider ZIP Code",
  },
  {
    key: "providerNotes.message",
    label: "Provider Note",
  },
  {
    key: "requestingProviderContactHeading",
    label: "Requesting Provider Contact",
  },
  {
    key: "requestingProvider.extension",
    label: "Requesting Provider Contact Extension",
  },
  {
    key: "requestingProvider.phone",
    label: "Requesting Provider Contact Phone",
  },
  {
    key: "requestingProvider.contactName",
    label: "Requesting Provider Contact Name",
  },
  {
    key: "requestingProvider.fax",
    label: "Requesting Provider Contact Fax",
  },
  {
    key: "subscriberHeading",
    label: "Subscriber",
  },
  {
    key: "subscriber.firstName",
    label: "Subscriber First Name",
  },
  {
    key: "subscriber.lastName",
    label: "Subscriber Last Name",
  },
  {
    key: "subscriber.memberId",
    label: "Subscriber Member ID",
  },
  {
    key: "patientHeading",
    label: "Patient",
  },
  {
    key: "patient.firstName",
    label: "Patient First Name",
  },
  {
    key: "patient.lastName",
    label: "Patient Last Name",
  },
  {
    key: "patient.birthDate",
    label: "Patient Date of Birth",
  },
  { key: "patient.genderCode", label: "Patient Gender" },
  {
    key: "patient.subscriberRelationshipCode",
    label: "Patient's Relationship to Subscriber",
  },
  {
    key: "diagnoses",
    label: "Diagnoses",
  },
  {
    key: "renderingProviders",
    label: "Rendering Provider",
  },
  {
    key: "procedures",
    label: "Procedures",
  },
];

export const activeSectionsList = [
  "serviceDetailsHeading",
  "requestingProviderHeading",
  "subscriberHeading",
  "patientHeading",
  "diagnosesHeading",
  "renderingProvidersHeading",
  "proceduresHeading",
];
